import { Box, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { useGreenhouseForm } from '../EsgGreenhouseFormProvider';
import CarbonNeutrality from './CarbonNeutrality/CarbonNeutrality';
import GreenhouseGoal from './GreenhouseGoal/GreenhouseGoal';
import GreenhouseGoalTermCompletedCheckbox from './GreenhouseGoalTermCompletedCheckbox';
import GreenhouseIntroduction, {
  GH_GOAL_TERM_INTRODUCTION_ID,
} from './GreenhouseGoalTermIntroduction';
import GreenhouseGoalTermProvider from './GreenhouseGoalTermProvider';
import GreenhouseGoalTermRemark, {
  GH_GOAL_TERM_REMARK_ID,
} from './GreenhouseGoalTermRemark';
import NetZero from './NetZero';
import OtherGreenhouseGas from './OtherGreenhouseGas';

const GreenhouseGoalTerm = () => {
  const { watch } = useGreenhouseForm();
  const goals = watch('greenhouseGoalTerm.greenhouseGoal.goals');
  const { netZero, carbon, other } = goals || {};

  return (
    <Box bgcolor={'white'}>
      <Box p={2}>
        <Flex gap={1}>
          <Typography fontWeight={800}>
            การตั้งเป้าหมายการปล่อยก๊าซเรือนกระจกระยะสั้น (short term)
            และ/หรือระยะยาว (long term)
          </Typography>
          <Flex gap={0.5} alignItems={'center'}>
            <GreenhouseIntroduction />
            <GreenhouseGoalTermRemark />
          </Flex>
        </Flex>
        <Box id={GH_GOAL_TERM_INTRODUCTION_ID} />
        <Box id={GH_GOAL_TERM_REMARK_ID} />
        <GreenhouseGoalTermProvider>
          <GreenhouseGoal />
          {netZero && <NetZero />}
          {carbon && <CarbonNeutrality />}
          {other && <OtherGreenhouseGas />}
        </GreenhouseGoalTermProvider>
      </Box>
      <GreenhouseGoalTermCompletedCheckbox />
    </Box>
  );
};

export default GreenhouseGoalTerm;
